export default function DraftRecoveryChoices({ draft, onChoose }) {
  const copies = draft?.alternatives || [];
  if (copies.length < 2) return null;
  return <label className="mt-2 block text-sm">
    {copies.length} recovery copies are retained from your tabs. Review a copy before restoring.
    <select aria-label="Recovery copy" className="ml-2 rounded border border-slate-300 bg-white px-2 py-1" value={draft.writerId || "legacy"} onChange={event => {
      const chosen = copies.find(copy => (copy.writerId || "legacy") === event.target.value);
      if (chosen) onChoose({ ...chosen, alternatives: copies });
    }}>
      {copies.map((copy, index) => <option key={copy.writerId || "legacy"} value={copy.writerId || "legacy"}>Copy {index + 1} · {new Date(copy.savedAt).toLocaleString()}</option>)}
    </select>
  </label>;
}
